/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-12-31 15:16:48                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2024-12-31 17:01:12                               *
 *****************************************************************************/

/* SUMMARY
  * CompInfoInputTextarea: Textarea compinfo component
*/

/**
* CompInfoInputTextarea: Textarea compinfo component
* @param value - current value
* @param onChange - on value change event
* @param className - additional classname
*/
export default function CompInfoInputTextarea({
  value,
  onChange,
  className = ""
}: {
  value: string,
  onChange: (data: string) => void,
  className?: string
}) {
  return (
    <>
      <textarea placeholder="ex: ..."
                value={value}
                className={className}
                onChange={(el) => onChange(el.target.value)}>
      </textarea>
    </>
  );
}
/***/
